// MyGarage Feature

// Add show/hide to buttons w/triggers
function modelTrigger(value) {
  const modals = Array.from(document.getElementsByClassName(value));
  for (let i = 0; i < modals.length; i++) {
    if (modals[i].style.display === "none") {
      modals[i].style.display = "block";
    } else {
      modals[i].style.display = "none";
    }
  }
}

// Parse Cookies when required
function parseCookieString(cookieString) {
  return cookieString.split(";").reduce(function (cookieObject, cookie) {
    let parts = cookie.split("=");
    cookieObject[parts.shift().trim()] = decodeURI(parts.join("="));
    return cookieObject;
  }, {});
}

// Add Vehicle
function handleSubmit(event) {
  event.preventDefault();

  const selectMake = document.getElementById("makeDropdown");
  const selectModel = document.getElementById("modelDropdown");
  const valueToAdd = `${selectMake.value} ${selectModel.value}`;
  console.log("Trigger Event: " + valueToAdd);

  let cookieObject = parseCookieString(document.cookie);
  let myGarageArray = JSON.parse(cookieObject.myGarage || "[]");
  let valueExistsInGarage = myGarageArray.includes(valueToAdd);
  if (!valueExistsInGarage) {
    myGarageArray.push(valueToAdd);
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    document.cookie =
      "myGarage=" +
      JSON.stringify(myGarageArray) +
      "; expires=" +
      expiryDate.toUTCString() +
      "; path=/";
  }
  refreshCookieArray();
  filterGarageItem(valueToAdd);
}

function addVehicle(value) {
  const valueToAdd = value;
  let cookieObject = parseCookieString(document.cookie);
  let myGarageArray = JSON.parse(cookieObject.myGarage || "[]");
  let valueExistsInGarage = myGarageArray.includes(valueToAdd);
  if (!valueExistsInGarage) {
    myGarageArray.push(valueToAdd);
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    document.cookie =
      "myGarage=" +
      JSON.stringify(myGarageArray) +
      "; expires=" +
      expiryDate.toUTCString() +
      "; path=/";
  }
  filterGarageItem(valueToAdd);
  refreshCookieArray();
}

// Make a Filter Active
function filterGarageItem(value) {
  // Touching the garage is a deliberate choice and outranks whatever unsaved
  // vehicle the shopper happened to browse through earlier.
  clearContextVehicle();
  let cookieObject = parseCookieString(document.cookie);
  let myGarageArray = JSON.parse(cookieObject?.myActiveGarage ?? "[]");
  let valueExistsInGarage = myGarageArray.includes(value);
  var targetFilter = document.querySelector(
    `.vehicle-compatibility-content .checkbox[value="${value}"]`
  );
  if (!valueExistsInGarage) {
    myGarageArray = ["" + value + ""];
    refreshLinks(value);
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    document.cookie =
      "myActiveGarage=" +
      JSON.stringify(myGarageArray) +
      "; expires=" +
      expiryDate.toUTCString() +
      "; path=/";
    document.getElementById("modelBackup").click();
  } else {
    myGarageArray = [];
    refreshLinks(value);
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    document.cookie =
      "myActiveGarage=" +
      JSON.stringify(myGarageArray) +
      "; expires=" +
      expiryDate.toUTCString() +
      "; path=/";
      if (document.getElementById("clearAll") !== null){
      document.getElementById("clearAll").click();
      } else {
      document.getElementById("modelBackup").href = clearFilterHref("?sort_by=best-selling");
      document.getElementById("modelBackup").click();
      }
  }
}

// Search results, unlike a collection, keep their products in the query string:
// q holds the search term and the theme's facet form submits type and options[*]
// alongside it. A garage link that carries only the vehicle filter therefore
// lands on an empty search, which is why My Garage did nothing on /search.
const SEARCH_CONTEXT_FIELDS = [
  "q",
  "type",
  "options[prefix]",
  "options[unavailable_products]",
];

function onSearchPage() {
  const garage = document.getElementById("garageFiltering");
  return garage !== null && garage.dataset.pageType === "search";
}

// Read the search context off the theme's own facet form rather than rebuilding
// it, so the values always match what a normal filter checkbox would submit.
function searchContextParams() {
  const form = document.getElementById("facet-filters-form");
  if (!onSearchPage() || form === null) {
    return "";
  }
  return SEARCH_CONTEXT_FIELDS.reduce(function (parts, name) {
    const field = form.querySelector(`[name="${name}"]`);
    if (field && field.value !== "") {
      parts.push(
        encodeURIComponent(name) + "=" + encodeURIComponent(field.value)
      );
    }
    return parts;
  }, []).join("&");
}

// Only for links that stay on the current page. The SHOP BY CATEGORY menu points
// at collections, where q means a vendor/type lookup instead of a search term.
function withSearchContext(queryString) {
  const context = searchContextParams();
  if (!context) {
    return queryString;
  }
  return queryString ? `${queryString}&${context}` : `?${context}`;
}

// Where "clear the vehicle filter" should land. Collections drop their filters
// and re-sort; a search has to keep its query or it clears to no results.
function clearFilterHref(collectionQuery) {
  return onSearchPage() ? withSearchContext("") : collectionQuery;
}

// Where the banner's clear control should point. The theme already renders its
// own clear-filters link with the right href for this template, search context
// and sort included, so mirror that rather than rebuild it. The fallback covers
// a page that shows the banner without the facet drawer.
function clearAllHref() {
  var themeClear = document.getElementById("clearAll");
  var themeHref = themeClear ? themeClear.getAttribute("href") : "";
  return themeHref ? themeHref : clearFilterHref("?sort_by=");
}

// Clearing from the banner has to switch the vehicle off, not just drop it from
// the URL. A car left active is written straight back onto the banner by the next
// render, claiming a filter the grid is no longer applying, which is the mismatch
// this whole feature exists to remove. The car stays saved in myGarage; only the
// active selection and the unsaved browsing context go.
function clearVehicleFilter() {
  clearContextVehicle();
  var expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 365);
  document.cookie =
    "myActiveGarage=[]; expires=" + expiryDate.toUTCString() + "; path=/";
}

// The banner's clear control. data-action="clear-filters" is what the theme
// delegates on documentElement, so the grid re-renders over AJAX from wherever
// the banner happens to sit in the page.
//
// Left off chassis collection pages on purpose: there the vehicle scope is the
// path rather than the filter, and activeGarageItem reinstates the car on the
// next render, so a clear would visibly undo itself.
function clearVehicleFilterLink(value) {
  if (onChassisCollectionPage()) {
    return "";
  }
  var label = "Clear filter";
  var described = String(value).replace(/"/g, "&quot;");
  return (
    ' <a class="shopby-clear" href="' + clearAllHref() + '"' +
    ' data-action="clear-filters" onclick="clearVehicleFilter();"' +
    ' title="' + label + ': ' + described + '"' +
    ' aria-label="' + label + ': ' + described + '">' + label +
    '<svg class="shopby-clear__x" viewBox="0 0 10 10" aria-hidden="true" focusable="false">' +
    '<path d="M1.5 1.5 8.5 8.5M8.5 1.5 1.5 8.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
    "</svg></a>"
  );
}

// A vehicle can be active without ever being saved. Arriving from SHOP BY VEHICLE
// puts the filter in the URL, and the garage renders the banner and an "Add to
// Garage" prompt without writing a cookie, on purpose: an unsaved car is browsing
// context, not a stored preference.
//
// That context already travels. refreshLinks() rewrites the SHOP BY CATEGORY and
// SHOP BY PRODUCTS links with the unsaved vehicle's filter, so moving between
// collections keeps it. Search was the one exit that dropped it, because a search
// goes through a form rather than a rewritten link. Holding the context here is
// what closes that gap, not a new kind of stickiness.
//
// sessionStorage, not a cookie: this dies with the tab. A car the shopper never
// saved must not outlive the visit, and the only visible record of it is the
// banner, so it should not be able to quietly filter a session days later.
const GARAGE_CONTEXT_VEHICLE_KEY = "myGarageContextVehicle";

function rememberedContextVehicle() {
  try {
    return window.sessionStorage.getItem(GARAGE_CONTEXT_VEHICLE_KEY);
  } catch (e) {
    return null;
  }
}

function rememberContextVehicle(value) {
  try {
    window.sessionStorage.setItem(GARAGE_CONTEXT_VEHICLE_KEY, value);
  } catch (e) {
    // Private browsing. The unsaved vehicle stops carrying into search, which is
    // the behaviour before this change rather than a broken one.
  }
}

function clearContextVehicle() {
  try {
    window.sessionStorage.removeItem(GARAGE_CONTEXT_VEHICLE_KEY);
  } catch (e) {
    // Nothing stored to clear.
  }
}

// Renamed vehicle values, old spelling to new. A saved car is stored as the full
// vehicle string and goes straight into filter.p.m.vehicle.compatibility, so a
// car saved before a rename would filter to nothing with no error. Rewritten once
// on load, before DOMContentLoaded reads the garage. The cookies last 365 days, so
// an entry can be removed a year after its rename.
const RENAMED_VEHICLES = {
  // 2026-10-07: R35 moves to Nissan's official GT-R spelling.
  "NISSAN R35 GTR": "NISSAN R35 GT-R",
  "日産 R35 GTR": "日産 R35 GT-R",
};

function migrateRenamedVehicles() {
  const rename = (value) => RENAMED_VEHICLES[value] ?? value;
  const cookieObject = parseCookieString(document.cookie);
  ["myGarage", "myActiveGarage"].forEach((name) => {
    if (!cookieObject[name]) return;
    let values;
    try {
      values = JSON.parse(cookieObject[name]);
    } catch (e) {
      return;
    }
    if (!Array.isArray(values)) return;
    // A garage holding both spellings collapses to one entry.
    const migrated = [...new Set(values.map(rename))];
    if (migrated.toString() === values.toString()) return;
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    document.cookie =
      name +
      "=" +
      JSON.stringify(migrated) +
      "; expires=" +
      expiryDate.toUTCString() +
      "; path=/";
  });
  const contextVehicle = rememberedContextVehicle();
  if (contextVehicle && RENAMED_VEHICLES[contextVehicle]) {
    rememberContextVehicle(RENAMED_VEHICLES[contextVehicle]);
  }
}

migrateRenamedVehicles();

// A new search term arrives with no vehicle filter in the URL: the search form
// submits q and type only, so nothing carries the garage across. The garage is a
// standing preference, so re-apply it rather than leave the banner and the green
// chip claiming a filter the grid is not applying.
//
// Gated on how the page arrived, not on the search term. A new search is always a
// real document load; every in-page filter interaction arrives as an AJAX
// theme:loading:end instead. That split is what lets a shopper pull the vehicle
// chip out of the filter list and have it stay out without the garage snapping it
// back a frame later, and it needs no memory of what was searched before. An
// earlier version keyed this on the term, which silently did nothing whenever a
// term was repeated in the same tab.
var garageDocumentLoad = true;

function applyGarageToNewSearch(activeVehicles) {
  if (!onSearchPage()) {
    return;
  }

  // An AJAX facet update rather than a new search. Leave it alone.
  if (!garageDocumentLoad) {
    return;
  }

  var params = new URLSearchParams(window.location.search);
  if (params.get("filter.p.m.vehicle.compatibility") !== null) {
    return;
  }
  if ((params.get("q") || "") === "") {
    return;
  }

  // A saved car wins. Falling back to the unsaved one keeps SHOP BY VEHICLE
  // browsing intact through a search, which is what the rewritten menu links
  // already do for collection browsing.
  var fromGarage = activeVehicles && activeVehicles.length > 0;
  var vehicle = fromGarage ? activeVehicles[0] : rememberedContextVehicle();
  if (!vehicle) {
    return;
  }

  // refreshLinks() has only put a garage vehicle on modelBackup. An unsaved one
  // has to be written on now, which also brings the banner back.
  if (!fromGarage) {
    refreshLinks(vehicle);
  }

  var modelBackup = document.getElementById("modelBackup");
  if (!modelBackup || !modelBackup.getAttribute("href")) {
    return;
  }

  // refreshLinks() has already pointed modelBackup at this search plus the
  // vehicle filter and left data-action="clear-filters" on it, so this click goes
  // through the theme's AJAX facet path: the grid re-renders, there is no page
  // load, and history.replaceState puts the filter in the address bar.
  modelBackup.click();
}

// Refresh Links on the page to reflect current filter
function refreshLinks(value) {
  const menuItems = document.querySelectorAll(
    '.header__linklist-item[data-item-title="SHOP BY CATEGORY"] a, .header__linklist-item[data-item-title="SHOP BY PRODUCTS"] a, .vehicle-filter-links'
  );
  let url = new URL(window.location.href);
  let searchParams = url.searchParams;
  value1 = value.toString().replace(/ /g, "+");
  var urlValue = `?filter.p.m.vehicle.compatibility=${value1}`;

  // Not every template that renders the garage also renders the banner, so a
  // missing one must not abort the link rewriting below.
  var shopByMessage = document.getElementById("shopby-message");
  var garageSelection = document.getElementById("garageselection");

  if (urlValue == "?filter.p.m.vehicle.compatibility=") {
    var urlValue = ``;
    if (shopByMessage) {
      shopByMessage.style.opacity = "0";
      shopByMessage.innerHTML = `No car selected. Select a car from your garage to shop by vehicle.`;
    }
    if (garageSelection) {
      garageSelection.innerHTML = `<h3>My Garage</h3><h4>Start by adding your vehicle below.</h4><img src="https://cdn.shopify.com/s/files/1/0684/0772/2259/files/CFilter.png?v=1679880864" />`;
    }
  } else {
    if (shopByMessage) {
      shopByMessage.style.opacity = "1";
      shopByMessage.innerHTML =
        `Now shopping for <span style="font-weight: 500;">${value}</span> products.` +
        clearVehicleFilterLink(value);
    }
    if (garageSelection) {
      garageSelection.innerHTML = `<h3>Now shopping for</h3><h4>${value}</h4><img src="https://cdn.shopify.com/s/files/1/0684/0772/2259/files/CFilter.png?v=1679880864" />`;
      garageSelection.style.backgroundColor = "#bcffc6";
    }
    searchParams.forEach((value1, key) => {
      if (
        key == "filter.v.price.lte" ||
        key == "filter.v.price.gte" ||
        key == "sort_by" ||
        key == "filter.p.tag"
      ) {
        urlValue = `${urlValue}&${key}=${value1}`;
      }
    });
  }

  (menuItems ?? []).forEach((a) => {
    if (a.href.includes("#")) {
      return;
    }
    let inurl = new URL(a.href);
    inurl.search = "";
    a.href = inurl.href + urlValue;
  });

  var destination = urlValue ? garageFilterDestination(value) : "";
  var modelBackup = document.getElementById("modelBackup");

  // FacetFilters in theme.js intercepts clicks on [data-action="clear-filters"]
  // document-wide, prevents the navigation and AJAX-swaps only the product grid.
  // That is correct while the href stays on the current collection, but a
  // cross-collection destination must be a real page load, otherwise the grid
  // shows the new chassis while the H1, copy and sub-filter buttons still
  // belong to the old one.
  if (destination) {
    modelBackup.removeAttribute("data-action");
  } else {
    modelBackup.setAttribute("data-action", "clear-filters");
  }

  // destination is only ever set on a chassis collection, so on search this stays
  // on /search and picks up the query the results were built from.
  modelBackup.href = destination + withSearchContext(urlValue);
}

// Decide which collection the garage filter should be applied to.
//
// modelBackup's href is query-only, so it resolves against whatever path you are
// currently on. That was fine while every vehicle link pointed at
// /collections/all-products, but a chassis collection holds one chassis only, so
// filtering inside /collections/s13 for a Scion returns nothing.
//
// Only chassis collections are redirected. Category collections keep filtering in
// place, which is what "show me brakes for my car" should do. An unknown vehicle,
// or one whose collection is not published yet, falls back to all-products, which
// is the behaviour this replaced.
function garageFilterDestination(value) {
  // Filtering in place is right on a category collection and wrong on a chassis
  // one, where the title, the copy and the sub-filter row all belong to a single
  // car and only the grid would change.
  if (!onChassisCollectionPage()) {
    return "";
  }

  var vehicleCollections = window.GKTECH_VEHICLE_COLLECTIONS || {};
  var currentHandle = currentCollectionHandle();
  var targetHandle = vehicleCollections[String(value)];

  if (!targetHandle) {
    return "/collections/all-products";
  }

  targetHandle = String(targetHandle).toLowerCase();
  return targetHandle === currentHandle ? "" : "/collections/" + targetHandle;
}

// The collection handle in the current URL, or "" when not on a collection page.
function currentCollectionHandle() {
  var pathParts = window.location.pathname.split("/collections/");
  // Downcased because Shopify serves a collection under any casing and the SHOP
  // BY VEHICLE menu links to /collections/V35-skyline, so the handle cannot be
  // compared as it was typed.
  return pathParts.length > 1 ? pathParts[1].split("/")[0].toLowerCase() : "";
}

// Every collection handle that stands for a single chassis, merged from two
// sources: the hand-maintained vehicle map, and the SHOP BY VEHICLE menu that
// vehicle-collection-map.liquid emits alongside it. The menu is the one that
// keeps this honest, because it gets updated as a matter of course when a
// chassis collection goes live, where the map is a list somebody has to
// remember to edit. When they disagree it is the map that is stale, and the
// consequence is not cosmetic: an unrecognised chassis collection gets filtered
// in place, so /collections/r31-skyline would happily render an R31 title over
// a grid of Z33 parts.
function chassisCollectionHandles() {
  var handles = {};
  var vehicleCollections = window.GKTECH_VEHICLE_COLLECTIONS || {};
  for (var vehicle in vehicleCollections) {
    handles[String(vehicleCollections[vehicle]).toLowerCase()] = true;
  }
  var declared = window.GKTECH_CHASSIS_COLLECTIONS || [];
  for (var i = 0; i < declared.length; i++) {
    handles[String(declared[i]).toLowerCase()] = true;
  }
  return handles;
}

// Is the current page one of the dedicated chassis collections? Uses the same
// handle lookup as garageFilterDestination. Needed because not every chassis
// collection renders a sub-filter row (the BMW and S15 pages have none), so the
// a[data-show-all] anchor alone under-detects a chassis page.
function onChassisCollectionPage() {
  var currentHandle = currentCollectionHandle();
  return currentHandle !== "" && chassisCollectionHandles()[currentHandle] === true;
}

// Which saved garage vehicle, if any, belongs to the chassis collection being
// viewed. More than one garage vehicle can map to the same collection (the S13
// variants all map to s13), so an already-active vehicle wins over garage order.
function garageVehicleForCurrentChassis(garageVehicles) {
  var vehicleCollections = window.GKTECH_VEHICLE_COLLECTIONS || {};
  var currentHandle = currentCollectionHandle();
  if (!currentHandle) {
    return null;
  }
  var cookieObject = parseCookieString(document.cookie);
  var activeVehicles = JSON.parse(cookieObject.myActiveGarage ?? "[]");
  var candidates = activeVehicles.concat(garageVehicles || []);
  for (var i = 0; i < candidates.length; i++) {
    if (String(vehicleCollections[String(candidates[i])] || "").toLowerCase() === currentHandle) {
      return candidates[i];
    }
  }
  return null;
}

// Apply Active Class
function activeGarageItem(value) {
  // If Parameters are applied, double check they exist in the garage first.
    let compatValue = new URLSearchParams(window.location.search)?.get('filter.p.m.vehicle.compatibility');
    console.log(compatValue);
    // A chassis collection page with no vehicle filter in the URL needs the
    // active garage vehicle reconciled against the chassis being viewed.
    //
    // With a sub-filter row (a[data-show-all]), no filter means the SHOW ALL
    // state, which an active vehicle would contradict, so deactivate.
    //
    // Without a sub-filter row there is nothing to narrow, so there is no SHOW
    // ALL state to protect. If the shopper already has this chassis in their
    // garage, make it the active vehicle instead: the grid is already scoped to
    // this chassis, so this only lights up the garage UI and carries the filter
    // onto the SHOP BY CATEGORY links. Otherwise deactivate, which is what stops
    // an unrelated car (a GT86 on a BMW page) staying stuck. Either way the car
    // stays saved in the garage.
    if (compatValue === null && (document.querySelector("a[data-show-all]") || onChassisCollectionPage())) {
      let chassisCookieObject = parseCookieString(document.cookie);
      let chassisActiveArray = JSON.parse(chassisCookieObject.myActiveGarage ?? "[]");
      let chassisMatch = document.querySelector("a[data-show-all]")
        ? null
        : garageVehicleForCurrentChassis(value);
      let chassisNextArray = chassisMatch ? [chassisMatch] : [];
      if (chassisActiveArray.toString() !== chassisNextArray.toString()) {
        let expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + 365);
        document.cookie =
          "myActiveGarage=" +
          JSON.stringify(chassisNextArray) +
          "; expires=" +
          expiryDate.toUTCString() +
          "; path=/";
      }
    }
    if (compatValue && compatValue !== null){
    if (value && value.includes(compatValue)){
    console.log('Boom! ' + compatValue + ' is in your garage. Continue.. ');
    } else {
    console.log('Uh Oh, New Vehicle. Not in Garage. Revert. REVERT!');
    var clearAll = document.createElement("div");
    var garageSelection = document.getElementById("garageselection");
    clearAll.innerHTML = `<div style="padding-bottom:18px;" class="myGarageOptions">
    <button style="border: 1px solid #fff;" class="myGarageItem button button--secondary" onclick="addVehicle('${compatValue}');">Add to Garage</button>
    <a style="border: 1px solid #fff;" class="myGarageItem button button--ternary" style="display: flex;" href="${clearFilterHref("?sort_by=")}" data-action="clear-filters" onclick="clearContextVehicle();">Clear Filter</a>
  </div>`;
    garageSelection.after(clearAll);
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    document.cookie = "myActiveGarage=[]; expires=" + expiryDate.toUTCString() + "; path=/";
    rememberContextVehicle(compatValue);
    refreshLinks(compatValue);
    return;
    }
    }
  // In garage? Boom! Continue.
  if (
    document.cookie
      .split(";")
      .some((item) => item.trim().startsWith("myActiveGarage="))
  ) {
    // Get all elements with class "myClass"
    var inputs = document.querySelectorAll(
      ".vehicle-compatibility-content input"
    );
    // Create an empty array to store the values
    var vehicleCompatFilters = [];
    // Loop through the elements and add their values to the array
    // Loop through the input elements and add their values to the array
    for (var i = 0; i < inputs.length; i++) {
      // Only add the value if the input is not a button or submit type
      if (inputs[i].type !== "button" && inputs[i].type !== "submit") {
        vehicleCompatFilters.push(inputs[i].value);
      }
    }    
    // Check if the cookie exists
    let cookieObject = parseCookieString(document.cookie);
    let myActiveGarageArray = JSON.parse(cookieObject.myActiveGarage ?? "[]");

    // Is the compatible vehicle set and in garage, but not active? Lets make it active.
    if (compatValue !== null && myActiveGarageArray.toString() !== compatValue){
      console.log('In garage but is not an active filter. Lets do this. URL: ' + compatValue + ' FilterArray ' + myActiveGarageArray);
      filterGarageItem(compatValue);
      return;
    }

    refreshLinks(myActiveGarageArray);
    if (value == null) {
      var emptyMessage = document.getElementById("shopby-message");
      var emptyIntro = document.getElementById("mygarage-intro");
      if (emptyMessage) {
        emptyMessage.style.opacity = "0";
        emptyMessage.innerHTML = `Use MyGarage to filter our store.`;
      }
      if (emptyIntro) {
        emptyIntro.innerHTML = `<div class="garageselection"><h3>My Garage</h3><h4>Start by adding your vehicle below.</h4><img src="https://cdn.shopify.com/s/files/1/0684/0772/2259/files/CFilter.png?v=1679880864" /></div>`;
      }
    } else {
      value.forEach(function (values) {
        var targetElement = document.querySelector(
          `.myGarageItem[data-value="${values}"]`
        );
        if (myActiveGarageArray == values) {
          
          var targetElement = document.querySelector(
            `.myGarageItem[data-value="${myActiveGarageArray}"]`
          );
          targetElement.classList.add("active");
          console.log(
            `Vehicle ${myActiveGarageArray} is currently filtered from your Garage.`
          );
        } else
        // Update the HTML list with the contents of the array
        if (vehicleCompatFilters.includes(values)) {
        } else {
          console.log(
            `Vehicle ${values} has no products on this page. Make Inactive.`
          );
          targetElement.classList.add("inactive");
          targetElement.innerHTML = "(0) " + targetElement.innerHTML;
        }
      });
    }

    applyGarageToNewSearch(myActiveGarageArray);
  }
}

// Remove a Vehicle
function removeGarageItem(value) {
  let cookieObject = parseCookieString(document.cookie);
  let myGarageArray = JSON.parse(cookieObject.myGarage || "[]");
  let myActiveGarageArray = JSON.parse(cookieObject.myActiveGarage || "[]");

  let needReset = false;
  if (myActiveGarageArray.includes(value)) {
    needReset = true;
  }

  let indexGarage = myGarageArray.indexOf(value);
  if (indexGarage > -1) {
    myGarageArray.splice(indexGarage, 1);
  }
  let indexActive = myActiveGarageArray.indexOf(value);
  if (indexActive > -1) {
    myActiveGarageArray.splice(indexActive, 1);
  }

  let expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 365);
  document.cookie =
    "myGarage=" +
    JSON.stringify(myGarageArray) +
    "; expires=" +
    expiryDate.toUTCString() +
    "; path=/";
  document.cookie =
    "myActiveGarage=" +
    JSON.stringify(myActiveGarageArray) +
    "; expires=" +
    expiryDate.toUTCString() +
    "; path=/";

  if (needReset === true) {
    let reset = document.getElementById("clearAll");
    reset.click();
  } else {
    refreshCookieArray();
  }
}

// Refresh and Rebuild
function refreshCookieArray() {
  let cookieObject = parseCookieString(document.cookie);
  if (
    document.cookie
      .split(";")
      .some((item) => item.trim().startsWith("myGarage="))
  ) {
    let myGarageArray = JSON.parse(cookieObject.myGarage || "[]");
    if (myGarageArray.toString() === "" || myGarageArray.toString() === null) {
      let listHTML = `<div id="garageselection"><h3>My Garage</h3><h4>Start by adding your vehicle below.</h4><img src="https://cdn.shopify.com/s/files/1/0684/0772/2259/files/CFilter.png?v=1679880864" /></div>`;
      document.getElementById("myGarageList").innerHTML = listHTML;
      document.getElementById("editGarage").style.display = "none";
      activeGarageItem(myGarageArray);
    } else {
      let listHTML = `<div id="garageselection"></div>`;
          
      myGarageArray.forEach(function (item) {
        item_code = "'" + item + "'";
        listHTML += `<div class="myGarage"><button class="myGarageItem button button--ternary button--full" data-value="${item}" onclick="filterGarageItem(${item_code})"><span class="myGarageItemName">${item}</span><span></span></button><button style="display:none;" class="myGarageRemoval" onclick="removeGarageItem(${item_code})">x</button></div>`;
      });
      document.getElementById("myGarageList").innerHTML = listHTML;
      document.getElementById("editGarage").style.display = "flex";
      activeGarageItem(myGarageArray);
    }
  } else {
    let myGarageArray;
    let listHTML = `<div id="garageselection"><h3>My Garage</h3><h4>Start by adding your vehicle below.</h4><img src="https://cdn.shopify.com/s/files/1/0684/0772/2259/files/CFilter.png?v=1679880864" /></div>`;
      document.getElementById("myGarageList").innerHTML = listHTML;
      document.getElementById("editGarage").style.display = "none";
      activeGarageItem(myGarageArray);
  }
}

// List all them sexy models
const carModels = {
  UNIVERSAL: ["FIT"],
  NISSAN: [
    "S13 KA24 240SX",
    "S13 SR20 240SX/SILVIA",
    "S13 KA24 HATCH",
    "S13 SR20 240SX HATCH",
    "S14 240SX/SILVIA",
    "S15 SILVIA",
    "R32 SKYLINE GTS-T",
    "R32 SKYLINE GTS4",
    "R32 SKYLINE GTR",
    "R33 SKYLINE GTS",
    "R33 SKYLINE GTS-T",
    "R33 SKYLINE GTS4",
    "R33 SKYLINE GTR",
    "R34 SKYLINE GT",
    "R34 SKYLINE GT-T",
    "R34 SKYLINE GTR",
    "R35 GT-R",
    "RZ34 Z",
    "WGNC34 STAGEA",
    "Z33 350Z",
    "Z34 370Z",
    "Z32 300ZX",
    "C33 Laurel",
    "C34 Laurel",
    "C35 Laurel",
    "CEFIRO A31",
  ],
  INFINITI: [
    "G35",
    "G37",
  ],
  SUBARU: [
    "BRZ ZC6",
    "BRZ ZD8",
    "IMPREZA GE/GH",
    "IMPREZA GP/GJ",
    "IMPREZA GK/GT",
    "WRX/STI GE/GH/GR/GV",
    "WRX/STI VA",
    "WRX VB",
    "LEGACY BM/BR",
    "FORESTER SG",
    "FORESTER SH",
    "FORESTER SJ",
    "XV GP",
    "XV GT",
  ],
  SCION: ["FR-S ZN6"],
  TOYOTA: [
    "GT86 ZN6", 
    "GR86 ZN8",
    "JZX90", 
    "JZX100", 
    "JZX110",
  ],
  BMW: [
    "E8X (1 Series)",
    "F2X (2 Series)",
    "E9X (3 Series)",
    "F3X (3 and 4 Series)",
    "F8X (M2/M3/M4)",
    "G8X (M3/M4)",
    "Z4 (G29)",
  ],
  LEXUS: [
    //"IS200 GXE10",
    "IS200 SXE10",
    "IS300 JCE10",
    "JZS161/GS300",
  ],
};

// Refresh the models dropdown when a make is selected.
function loadModels(value) {
  let cookieObject = parseCookieString(document.cookie);
  let myGarageArray = JSON.parse(cookieObject.myGarage ?? "[]");
  let selectModel = document.getElementById("modelDropdown");
  if (carModels[value] && carModels[value].length) {
    selectModel.innerHTML = "<option value>Select Make</option>";
    for (let i = 0; i < carModels[value].length; i++) {
      let option = document.createElement("option");
      option.value = carModels[value][i];
      option.text = carModels[value][i];
      if (myGarageArray.includes(value + " " + carModels[value][i])) {
        option.disabled = true;
      }
      selectModel.add(option);
    }
    selectModel.disabled = false;
  } else {
    selectModel.innerHTML = "<option value>Select Make</option>";
    selectModel.disabled = true;
  }
}

// Add to Garage button should only display when make and model are selected
function buttonActive() {
  const selectMake = document.getElementById("makeDropdown");
  const selectModel = document.getElementById("modelDropdown");
  const addBtn = document.getElementById("addGarage");
  document.getElementById(
    "fullModel"
  ).value = `${selectMake.value} ${selectModel.value}`;
  if (selectMake.value.length == 0 || selectModel.value.length == 0) {
    addBtn.disabled = true;
    addBtn.classList.add("button--ternary");
    addBtn.classList.remove("button--secondary");
  } else {
    addBtn.disabled = false;
    addBtn.classList.add("button--secondary");
    addBtn.classList.remove("button--ternary");
  }
}

// Lights. Camera. Action! After page loads, fire up the vehicle filter.
document.addEventListener("DOMContentLoaded", function () {
  refreshCookieArray();
  // Everything after this is an AJAX re-render, including the one the garage may
  // have just triggered itself.
  garageDocumentLoad = false;
});
// Reload myGarage when an AJAX reload happens
window.addEventListener("theme:loading:end", () => {
  refreshCookieArray();
});
